import { createContext } from "react";
import React, { useContext, useState, useEffect } from "react";
import { UrlContext } from "./UrlContext";
import { useNavigate, useParams } from "react-router-dom";

export const ClientContext = createContext();

export const ClientProvider = ({ children }) => {
  const { API_URL, URI } = useContext(UrlContext);
  const newCode = window.location.href.split("&code=")[1];
  const pathSuffix = window.location.pathname.includes("/feedback") ? "/feedback" : "";
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [_projectID, setProjectID] = useState(null);
  const navigator = useNavigate();
  useEffect(() => {
    const validateCode = async () => {
      setLoading(true);
      if (newCode) {
        let code = newCode;
        try {
          const response = await fetch(`${API_URL}validate_code`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code }),
          });
          const data = await response.json();
          if (data.valid) {
            localStorage.setItem("clientToken", code);
            window.location.href = `${URI}${data.project_id}${pathSuffix}`;
            setProjectID(data.project_id);
            setIsAuthenticated(true);
            setLoading(false);
          } else {
            setError("Invalid or expired token");
            setLoading(false);
          }
        } catch (error) {
          setError("Error while validating token");
          setLoading(false);
        }
      } else {
        const storedToken = localStorage.getItem("clientToken");
        if (storedToken) {
          const response = await fetch(`${API_URL}validate_code`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code: storedToken }),
          });
          const data = await response.json();

          if (data.valid) {
            navigator(`/${data.project_id}${pathSuffix}`);
            setProjectID(data.project_id);
            setIsAuthenticated(true);
            setLoading(false);
            fetch(`${API_URL}client-visit-log/${data.project_id}`, {
              method: "GET",
              headers: { "Content-Type": "application/json" },
            });
            return;
          }
        } else {
          setError("Unauthorized");
          setLoading(false);
        }
      }
    };

    validateCode();
  }, []);
  return (
    <ClientContext.Provider
      value={{ isAuthenticated, error, loading, _projectID }}
    >
      {children}
    </ClientContext.Provider>
  );
};
